import { render } from "./CentroCostos.vue?vue&type=template&id=710fc29c"
import script from "./CentroCostos.vue?vue&type=script&lang=js"
export * from "./CentroCostos.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__